import Api from './api';

const convertYenRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/convert/yen', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const convertUsdRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/convert/usd', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const getAllRatesRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/rates', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}

export default { convertYenRequest, convertUsdRequest, getAllRatesRequest }



// WEBPACK FOOTER //
// ./src/api/apiRates.js